import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    '& .logo-icon': {
      transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    }
  }
}));

function Logo() {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, 'flex items-center')}>
      <Link role="button" to="/" className="flex items-center logo-icon no-underline">
        <img className="w-56 h-56" src="assets/images/logos/turp.svg" alt="Turp logo" />
        <div className="bg-white rounded-full"></div>
        <Typography
          variant="h5"
          className="tracking-widest text-20 flex-1 mx-16 font-bold"
          color="primary">
          Turp
          <span className="truncate"> Panel</span>
        </Typography>
      </Link>
    </div>
  );
}

export default Logo;
